"use client";
import { LandingSiteTemplateGetDataMenuItemOutputApiModel } from "@/Apis/ClinicApi";
import { SmartLink } from "@/Components";
import { useAppSetting, useResponsive } from "@/Hooks";
import { Flex } from "antd";
import { usePathname } from "next/navigation";
import { FC, useEffect, useState } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import "./HeaderMenu.css";

interface MenuTreeItem extends LandingSiteTemplateGetDataMenuItemOutputApiModel {
  Children?: MenuTreeItem[];
}

function buildMenuTree(
  items: LandingSiteTemplateGetDataMenuItemOutputApiModel[],
): MenuTreeItem[] {
  const map = new Map<number, MenuTreeItem>();
  const roots: MenuTreeItem[] = [];

  items.forEach((item) => {
    map.set(item.Id, { ...item, Children: [] });
  });

  map.forEach((item) => {
    if (item.ParentId) {
      const parent = map.get(item.ParentId);
      if (parent) {
        parent.Children!.push(item);
      }
    } else {
      roots.push(item);
    }
  });

  return roots;
}

interface HeaderMenuProps {
  menuItems?: LandingSiteTemplateGetDataMenuItemOutputApiModel[];
}
const HeaderMenu: FC<HeaderMenuProps> = ({ menuItems = [] }) => {
  const { isMobile } = useResponsive();
  const { setMenuOpen, menuOpen } = useAppSetting();
  const pathname = usePathname();
  const isMenuItemActive = (item: MenuTreeItem): boolean => {
    if (item.Link && pathname === item.Link) return true;

    if (item.Children?.length) {
      return item.Children.some((child) => isMenuItemActive(child));
    }

    return false;
  };
  useEffect(() => {
    if (!isMobile || !menuOpen) return;
    setMenuOpen(false);
  }, [pathname]);

  const menuTree = buildMenuTree(menuItems);
  const [openDynamicMenus, setOpenDynamicMenus] = useState<Set<number>>(
    new Set(),
  );

  const toggleDynamicMenu = (id: number) => {
    if (!isMobile) return;
    setOpenDynamicMenus((prev) => {
      const next = new Set(prev);
      if (next.has(id)) {
        next.delete(id);
      } else {
        next.add(id);
      }
      return next;
    });
  };

  const renderMenuItems = (items: MenuTreeItem[], level: number = 0) =>
    items.map((item) => {
      const hasChildren = !!item.Children?.length;
      const isOpen = openDynamicMenus.has(item.Id);
      const isActive = isMenuItemActive(item);
      const shouldBeOpen = isMobile && (isOpen || isActive);

      return (
        <li key={item.Id} className={`has-submenu ${isActive ? "active" : ""}`}>
          {hasChildren ? (
            <a
              onClickCapture={(e) => e.preventDefault()}
              href=""
              // href="#"
              role="button"
              className={isOpen ? "subdrop" : ""}
              onClick={(e) => {
                e.preventDefault();
                toggleDynamicMenu(item.Id);
              }}
            >
              <Flex justify="space-between" align="center" gap={8}>
                {item.Title}
                {isOpen ? <FaChevronUp /> : <FaChevronDown />}
                {/* {(
                                    isMobile || level > 0   // 📱 موبایل: همه سطوح | 🖥 دسکتاپ: فقط زیرمنوها
                                ) && (
                                        isOpen ? <FaChevronUp /> : <FaChevronDown />
                                    )} */}
              </Flex>
            </a>
          ) : (
            <SmartLink href={item.Link} onClick={onhandleCloseMenu}>
              {item.Title}
            </SmartLink>
          )}

          {hasChildren && (
            <ul
              className={
                isMobile
                  ? shouldBeOpen
                    ? "submenu d-block"
                    : "submenu"
                  : "submenu"
              }
            >
              {renderMenuItems(item.Children!, level + 1)}
            </ul>
          )}
        </li>
      );
    });

  const onhandleCloseMenu = () => {
    const root = document.getElementsByTagName("html")[0];
    root.classList.remove("menu-opened");
  };

  return renderMenuItems(menuTree);
};

export default HeaderMenu;
